import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();
    const [lang, setLang] = React.useState(i18n.language || 'en');

    const handleChange = (event) => {
        const newLang = event.target.value;
        setLang(newLang);
        i18n.changeLanguage(newLang);
    };

    return (
        <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="language-select-label">{t('app.language')}</InputLabel>
            <Select labelId="language-select-label" value={lang} label={t('app.language')} onChange={handleChange}>
                <MenuItem value="en">{t('app.english')}</MenuItem>
                <MenuItem value="es">{t('app.spanish')}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default LanguageSwitcher;
